// fetchMessagesByUsingList.js
'use strict';
import fetchProfileMessages from './fetchProfileMessages.js';
import fetchChatroomMessages from './fetchChatroomMessages.js';
import fetchFeeds from './fetchFeeds.js';
import fetchDiscoverUsers from './fetchDiscoverUsers.js';
import fetchMessageSearch from './fetchMessageSearch.js';
import fetchFreeZoneMessages from '../action/fetchFreeZoneMessages.js';
import fetchUnlockedMessages from './fetchUnlockedMessages.js';
import fetchFollowing from './fetchFollowing.js';

import getRemoteConfigData from '../selector/getRemoteConfigData.js';
import getFeedName from '../selector/getFeedName.js';
import { getSelectedQueryOptionObject } from '../selector/getFeedQueryObject.js';
import getSelectedFeedQueryOptions from '../selector/getSelectedFeedQueryOptions.js';

import { PROFILE_FEED_REMOTE_CONFIG_KEY_MAP } from '../resource/profileConstants.js';
import { QueryPrefix, QueryType } from '../resource/feedConstants.js';

/**
 * Fetch messages by using list
 * @kind action
 * @param {Array} { usingList } - using messages list.
 * @param {number} { page } - page number.
 * @param {number} { limit } - page size.
 * @return {Promise} Action promise.
 */
const fetchMessagesByUsingList =
  ({ usingList, page = 1, limit = 10 }) =>
  async (dispatch, getState) => {
    const [head] = usingList;

    if (head === 'profile') {
      const type = usingList[2];
      const listId = usingList[3];

      await dispatch(
        fetchProfileMessages({ id: listId, listId: type, page, limit })
      );
    } else {
      const type = usingList[0];
      const id = usingList[1];

      if (type === 'outbox') {
        const userId = usingList[2];
        const listType = usingList[1];
        const feedNameRemoteConfigKey =
          PROFILE_FEED_REMOTE_CONFIG_KEY_MAP[listType];
        const outboxFeedName = getFeedName(
          getState(),
          feedNameRemoteConfigKey,
          '{USER_ID}',
          userId
        );
        const { feedNameWithQuery } = getSelectedQueryOptionObject(
          getState(),
          outboxFeedName,
          getSelectedFeedQueryOptions(
            getState(),
            feedNameRemoteConfigKey,
            undefined
          ),
          getRemoteConfigData(
            getState(),
            `${feedNameRemoteConfigKey}_${QueryPrefix[QueryType.SORT]}`
          )?.[0]
        );
        await dispatch(
          fetchFeeds({
            type: feedNameWithQuery,
            page,
          })
        );
      }

      if (type === 'chatroom') {
        await dispatch(
          fetchChatroomMessages({ id, page, isFetchMediaOnly: true })
        );
      }

      if (type === 'home') {
        const type = usingList[2];
        await dispatch(fetchFeeds({ page, type, limit }));
      }

      if (type === 'discover') {
        await dispatch(fetchDiscoverUsers({ category: id, page }));
      }

      if (type === 'search') {
        const type = usingList[2];
        const query = usingList[3];
        await dispatch(fetchMessageSearch({ query, queryUrl: page, type }));
      }

      if (type === 'freezone') {
        await dispatch(fetchFreeZoneMessages({ page }));
      }

      if (type === 'unlocked') {
        const [, , type, senderId] = usingList;
        await dispatch(
          fetchUnlockedMessages({
            page,
            limit,
            senderId,
            type,
          })
        );
      }

      if (type === 'following') {
        await dispatch(fetchFollowing({ page, limit }));
      }
    }
  };

export default fetchMessagesByUsingList;
